import Application from 'market-view-ui/components/application';
import UiLoading from 'market-view-ui/components/application/ui-loading';

<template>
  <Application>
    <UiLoading @isLoading={{true}} />
  </Application>
</template>
